import {
  BottomSheet,
  Illustration,
  Text,
  Title,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { useToast } from "@src/appV2/lib/Notifications";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { useDropVisit } from "@src/appV2/redesign/InHome/BookedVisitDetails/useDropVisit";
import { useHistory } from "react-router-dom";

import { LoadingButton } from "../../components/LoadingButton";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { BOOKED_VISIT_DROP_CONFIRMED_MODAL_PATH } from "../paths";

interface DropVisitBottomSheetProps {
  modalState: UseModalState;
}

export function DropVisitBottomSheet(props: DropVisitBottomSheetProps) {
  const { modalState } = props;
  const { visit, generateModalPath } = useInHomeVisitModalsDataContext();
  const history = useHistory();
  const { mutateAsync: dropVisit, isLoading } = useDropVisit(visit?.id ?? "");
  const { showErrorToast } = useToast();
  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" onClose={modalState.closeModal}>
          <LoadingButton
            fullWidth
            variant="destructive"
            isLoading={isLoading}
            onClick={async () => {
              try {
                await dropVisit();
                history.replace(
                  generateModalPath(BOOKED_VISIT_DROP_CONFIRMED_MODAL_PATH, {
                    caseId: visit?.attributes.caseId ?? "",
                    visitId: visit?.id ?? "",
                  })
                );
              } catch {
                showErrorToast("Unable to drop visit. Please try again.");
              }
            }}
          >
            Drop visit
          </LoadingButton>
        </DialogFooter>
      }
    >
      <DialogContent>
        <Stack spacing={4} width="100%" alignItems="center">
          <Illustration type="cancellation" />
          <Title component="h2">Drop your visit?</Title>
          <Text variant="body2">
            This cancellation will penalize your Attendance Score by <b>-10</b>.
          </Text>
          <Text variant="body2">Are you sure you want to proceed?</Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
